import { render, staticRenderFns } from "./Prize_0.vue?vue&type=template&id=8ee79fb0&scoped=true"
import script from "./Prize_0.vue?vue&type=script&lang=js"
export * from "./Prize_0.vue?vue&type=script&lang=js"
import style0 from "./Prize_0.vue?vue&type=style&index=0&id=8ee79fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee79fb0",
  null
  
)

export default component.exports